import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a23f43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first-pdf-page" }
const _hoisted_2 = { class: "first-pdf-page__main" }
const _hoisted_3 = { class: "first-pdf-page__header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = { class: "text-bold" }
const _hoisted_7 = { class: "text-bold" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "first-pdf-page__title" }, "Пародонтальная карта", -1))
const _hoisted_10 = { class: "first-pdf-page__survey" }
const _hoisted_11 = { class: "first-pdf-page__survey-date" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Дата обследования", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "ФИО врача", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Должность", -1))
const _hoisted_15 = { class: "first-pdf-page__patient" }
const _hoisted_16 = { class: "first-pdf-page__patient-about" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("ФИО пациента:")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Дата рождения:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Мед карта:")
const _hoisted_20 = { class: "first-pdf-page__content" }
const _hoisted_21 = { class: "first-pdf-page__footer" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "first-pdf-page__footer-title" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "first-pdf-page__footer-text" }, " Результаты расчета не являются диагнозом или медицинской рекомендацией и не заменяют консультации с врачом. ")
], -1))
const _hoisted_23 = ["innerHTML"]

import { computed, onMounted, ref } from 'vue'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import {
  PatientType,
  PeriodontalDetailType,
  PeriodontalReportType,
} from '@/shared/types'
import { useUser } from '@/shared/composables'
import { patientApi } from '@/shared/api'
import { useRoute } from 'vue-router'
import { DATE_FORMAT, LOGO } from '@/shared/constants'
import { getDateFormat, showErrorMessage } from '@/shared/utils'

interface Props {
  data: PeriodontalReportType
  previousData: PeriodontalReportType
  reportInfo: PeriodontalDetailType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    previousData: null,
    reportInfo: null
  },
  setup(__props: any) {

const props = __props as {
  data: PeriodontalReportType
  previousData: PeriodontalReportType
  reportInfo: PeriodontalDetailType
}


const route = useRoute()

const { user } = useUser()

const patientInfo = ref<PatientType>({
  cart_number: '',
  date: '',
  id: 0,
  name: '',
  email: '',
  patronymic: '',
  phone: '',
  surname: '',
})

const date = computed((): string =>
  props.reportInfo.date_at
    ? getDateFormat(new Date(props.reportInfo.date_at), DATE_FORMAT.dmyLong)
    : ''
)

const logo = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return user.value.organization.logo
    ? `${domain}/api/web/admin/reports/storage/${user.value.organization.logo.id}`
    : ''
})

const patientId = computed((): string | string[] => route.params.patientId)
const reportId = computed((): string | string[] => route.params.reportId)
const birthday = computed(() => patientInfo.value.date)

const getPatientInfo = async (): Promise<void> => {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    patientInfo.value = response.data.patient
  }
}

onMounted((): void => {
  getPatientInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(logo),
          class: "first-pdf-page__logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.reportInfo.organization?.name), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.reportInfo.organization?.address), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.reportInfo.organization?.phone), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(__props.reportInfo.organization?.site), 1)
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createTextVNode("  " + _toDisplayString(_unref(date)), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _hoisted_13,
            _createTextVNode("  " + _toDisplayString(__props.reportInfo.doctor?.name), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_14,
            _createTextVNode("  " + _toDisplayString(__props.reportInfo.doctor?.position), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_row, { class: "first-pdf-page__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(patientInfo.value.surname) + " " + _toDisplayString(patientInfo.value.name) + " " + _toDisplayString(patientInfo.value.patronymic), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "first-pdf-page__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(birthday)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "first-pdf-page__patient-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 5,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 19 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(patientInfo.value.cart_number), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: __props.data.firstFacialData.getData(),
        class: "first-pdf-page__table",
        "is-pdf-mode": ""
      }, null, 8, ["columns"]),
      _createVNode(_unref(EPeriodontalGraphic), {
        "facial-side-data": __props.data.firstFacialDiagram,
        "tongue-side-data": __props.data.firstTongueDiagram,
        "facial-side-previous-data": __props.previousData?.firstFacialDiagram,
        "tongue-side-previous-data": __props.previousData?.firstTongueDiagram,
        "is-upper-teeth": true,
        class: "first-pdf-page__chart",
        "is-pdf-mode": ""
      }, null, 8, ["facial-side-data", "tongue-side-data", "facial-side-previous-data", "tongue-side-previous-data"]),
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: __props.data.firstTongueData.getData(),
        "is-pdf-mode": "",
        "is-reverse": ""
      }, null, 8, ["columns"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", { innerHTML: _unref(LOGO) }, null, 8, _hoisted_23)
    ])
  ]))
}
}

})